
import Index from "views/Index.js";

// import Profile from "views/Admin/Profile.js";
import Login from "views/Auth/Login.js";
import KeysManager from "views/Admin/KeysManager";
import PortfolioManager from "views/Admin/PortfolioManager";
import CapabilitiesManager from "views/Admin/CapabilitiesManager";
import ContractsManager from "views/Admin/ContractsManager";
import StorageManager from "views/Admin/StorageManager";
import ChildAccountsManager from "views/Admin/ChildAccountsManger";

// import Maps from "views/examples/Maps.js";
// import Register from "views/examples/Register.js";

// import Icons from "views/examples/Icons.js";

var routes = [
  {
    path: "/",
    name: "Dashboard",
    icon: "ni ni-tv-2 text-primary",
    component: Index,
    layout: "/admin",
    isSidebarLink: true,
    indexRoute: true
  },

  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   icon: "ni ni-single-02 text-yellow",
  //   component: Profile,
  //   layout: "/admin",
  //   isSidebarLink: true,
  //   indexRoute: false
  // },
  {
    path: "/keys-manager",
    name: "Keys Manager",
    icon: "ni ni-bullet-list-67 text-red",
    component: KeysManager,
    layout: "/admin",
    isSidebarLink: true,
    indexRoute: false
  },
  {
    path: "/capabilities-manager",
    name: "Capabilities Manager",
    icon: "ni ni-bullet-list-67 text-red",
    component: CapabilitiesManager,
    layout: "/admin",
    isSidebarLink: true,
    indexRoute: false
  },
  {
    path: "/storage-manager",
    name: "Storage Manager",
    icon: "ni ni-bullet-list-67 text-red",
    component: StorageManager,
    layout: "/admin",
    isSidebarLink: true,
    indexRoute: false
  },
  {
    path: "/childaccounts-manager",
    name: "Hybrid Custody Manager",
    icon: "ni ni-bullet-list-67 text-red",
    component: ChildAccountsManager,
    layout: "/admin",
    isSidebarLink: true,
    indexRoute: false
  },
  {
    path: "/contracts-manager",
    name: "My Contracts",
    icon: "ni ni-bullet-list-67 text-red",
    component: ContractsManager,
    layout: "/admin",
    isSidebarLink: true,
    indexRoute: false
  },
  {
    path: "/portfolio-manager",
    name: "Portfolio",
    icon: "ni ni-bullet-list-67 text-red",
    component: PortfolioManager,
    layout: "/admin",
    isSidebarLink: true,
    indexRoute: false
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-info",
    component: Login,
    layout: "/auth",
    isSidebarLink: false,
    indexRoute: true
  },
  // {
  //   path: "/register",
  //   name: "Register",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: Register,
  //   layout: "/auth"
  // },

];
export default routes;
